import axios from "axios";
import env from "../config";
// import { setNotification, useNotifcation } from 'context/notification'
import { ReqMethods, ResponseStatus } from "../enums";
// import { useAuth, useLogout } from './auth'

const BASE_URL = `${env.API_URL}`;

function useServiceHandler() {
  // const [, dispatch] = useNotifcation()
  // const Logout = useLogout()

  return (fn) =>
    async (
      method,
      path,
      { query, payload, token, apiKey, toaster, message, error } = {}
    ) => {
      try {
        const res = await fn(method, path, { query, payload, token, apiKey });
        // console.log("API - RESPONSE", res, toaster, message, error);
        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: message || res.data.message,
        //     severity: 'success',
        //     title: 'Success',
        //   })

        return { response: res.data };
      } catch (err) {
        // console.log("API- ERROR", err.response?.data || err);

        // expire error : jwt expired
        if (
          err.response &&
          err.response.status === ResponseStatus.UNAUTHORIZED
        ) {
          // setNotification(dispatch, {
          //   open: true,
          //   message: error || 'session expired',
          //   title: 'Error',
          //   severity: 'error',
          // })
          // setTimeout(Logout, 4000)
          return { error: err.response?.data || err };
        }

        const customError = err.response?.data?.error
          ? `${err.response?.data?.message} \n${err.response?.data?.error}`
          : err.response?.data?.message;

        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: error || customError || err.message,
        //     severity: 'error',
        //     title: 'Error',
        //   })
        return { error: err.response ? err.response.data : err };
      }
    };
}

function useCallService() {
  // const authToken = useAuth()
  const serviceHandler = useServiceHandler();

  const CallService = (
    method,
    path,
    { query, payload, token = true, apiKey = null }
  ) => {
    const pathname = query ? `${path}?${query}` : path;
    const config = {};

    // if (token) config.headers = { 'x-auth-token': `Bearer ${authToken || token}` }
    // if (apiKey) config.headers = { apiKey }

    const details = {};

    if (payload) details.payload = payload;
    details.config = config;

    return axios[method](pathname, ...Object.values(details));
  };

  return serviceHandler(CallService);
}

function useAppServices() {
  const { GET, POST, PUT, DELETE } = ReqMethods;
  const CallService = useCallService();

  /**
    Option for service is the object that could has the following properties
    query, payload, token, apiKey
  */

  const APIs = {
    auth: {
      integrate_app: (options) =>
        CallService(POST, `${BASE_URL}/auth/integrate_app`, options),
      login: (options) => CallService(POST, `${BASE_URL}/auth/login`, options),

      superadmin_login: (options) =>
        CallService(POST, `${BASE_URL}/auth/superadmin_login`, options),
      CreateTeam: (options) =>
        CallService(POST, `${BASE_URL}/auth/team`, options),
      UpdateTeam: (options) =>
        CallService(PUT, `${BASE_URL}/auth/team`, options),
      DeleteTeam: (options) => CallService(DELETE, `${BASE_URL}/user`, options),
    },
    dashboard: {
      crm_genix: (options) =>
        CallService(GET, `${BASE_URL}/dashboard/crm_genix`, options),
    },
    apps: {
      get: (options) => CallService(GET, `${BASE_URL}/apps`, options),
      create: (options) => CallService(POST, `${BASE_URL}/apps`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/apps/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/apps`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/apps`, options),
    },
    support: {
      get_tickets: (options) =>
        CallService(GET, `${BASE_URL}/support/get_tickets`, options),
      get_tickets_with_messages: (options) =>
        CallService(
          GET,
          `${BASE_URL}/support/get_tickets_with_messages`,
          options
        ),
      create_ticket: (options) =>
        CallService(POST, `${BASE_URL}/support/create_ticket`, options),
    },
    logs: {
      get_message_logs: (options) =>
        CallService(GET, `${BASE_URL}/logs/get_message_logs`, options),
    },
    app_installs: {
      get: (options) => CallService(GET, `${BASE_URL}/app_installs`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/app_installs`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/app_installs/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/app_installs`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/app_installs`, options),
    },
    user: {
      get: (options) => CallService(GET, `${BASE_URL}/user`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/user/filter`, options),
      GetTeam: (options) => CallService(GET, `${BASE_URL}/user/teams`, options),
    },
    agency: {
      get: (options) => CallService(GET, `${BASE_URL}/agency`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/agency/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/agency`, options),
      getProducts: (options) =>
        CallService(PUT, `${BASE_URL}/agency/getproducts`, options),
    },
    utils: {
      upload_image: (options) =>
        CallService(POST, `${BASE_URL}/utils/upload/image`, options),
    },
    services: {
      ghl: {
        call_service: (options) =>
          CallService(POST, `${BASE_URL}/hooks/ghl`, options),
      },
    },
    quo: {
      get_phone_numbers: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/quo/get-phone-numbers/${options.appId}`,
          options
        ),
      preview_phone_numbers: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/quo/preview-phone-numbers/${options.appId}`,
          options
        ),
      get_location_users: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/quo/get-location-users/${options.appId}`,
          options
        ),
      ensure_webhook: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/quo/ensure-webhook/${options.appId}`,
          options
        ),
    },
    printful: {
      get_products: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/printful/get-products/${options.appId}`,
          options
        ),
      get_product: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/printful/get-product/${options.appId}`,
          options
        ),
      get_widget_settings: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/printful/widget-settings/${options.appId}`,
          options
        ),
      save_widget_settings: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/printful/widget-settings/${options.appId}`,
          options
        ),
    },
    servicem8: {
      get_auth_url: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/servicem8/get-auth-url/${options.appId}`,
          options
        ),
      get_token: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/servicem8/get-token/${options.appId}`,
          options
        ),
      connection_status: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/servicem8/connection-status/${options.appId}`,
          options
        ),
      test_connection: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/servicem8/test-connection/${options.appId}`,
          options
        ),
      disconnect: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/servicem8/disconnect/${options.appId}`,
          options
        ),
    },
    twilio: {
      get_phone_numbers: (options) =>
        CallService(
          GET,
          `${BASE_URL}/apps/action/twilio/get-phone-numbers/${options.appId}`,
          options
        ),
      preview_phone_numbers: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/twilio/preview-phone-numbers/${options.appId}`,
          options
        ),
      ensure_webhook: (options) =>
        CallService(
          POST,
          `${BASE_URL}/apps/action/twilio/ensure-webhook/${options.appId}`,
          options
        ),
    },
  };

  return APIs;
}
const useUploadImage = () => {
  const AppService = useAppServices();
  return ({ toaster, file, desiredPath }) => {
    const form = new FormData();
    form.append("image", file, file.name);
    return AppService.utils.upload_image({
      toaster,
      payload: form,
      query: `desiredPath=${desiredPath}`,
    });
  };
};
export { useAppServices, useCallService, useUploadImage };
